import { CIActionGuard, useUserPermission } from 'ccs-ui-components';
import { Button, Col, Dropdown, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import { requiredAuthPermission } from '../../../common/constants/UserPermissionConstants';
import { journeyBuilderRoutes } from '../../../journey-builder/constants/JdRoutes';
import EventIcon from '../../components/icons/EventIcon';
import JourneyIcon from '../../components/icons/JourneyIcon';
import ServiceIcon from '../../components/icons/ServiceIcon';
import classes from './CreateButtonSubHeader.module.scss';

const CreateButtonSubHeader = () => {
  const navigate = useNavigate();
  const { t: translate } = useTranslation();
  const { permissionObject } = useUserPermission();

  return (
    <div className={classes.container}>
      <Row className={classes['container-body']}>
        <Col xs={12} sm={12} md={6} className={classes['container-text']}>
          <h1 className={classes['heading-title']}>
            {translate('sub_header_component.subtitle_dashboard1')}
          </h1>
        </Col>
        <Col xs={12} sm={12} md={6} className={classes['container-text']}>
          <div className={classes['body-content']}>
            {CIActionGuard([requiredAuthPermission.Services.approve, requiredAuthPermission.Services.edit, requiredAuthPermission.Events.approve, requiredAuthPermission.Events.edit, requiredAuthPermission.JD.approve, requiredAuthPermission.JD.edit], permissionObject.permission) && (
              <div className={classes['actions-row']}>
                <Button
                  type="button"
                  variant="outline-primary"
                  className={classes['ai-design-btn']}
                  data-testid="ai-design-button"
                  onClick={() => navigate('/cipaidesigner')}
                >
                  {translate('sub_header_component.btn_cip_ai_assistant')}
                </Button>
                <Dropdown>
                  <Dropdown.Toggle
                    id="dropdown-create"
                    className={classes['dropdown-btn']}
                  >
                    <span className={classes['icon-plus']}><i className="bi bi-plus-circle" /></span>
                    <span className={classes['btn-title']}>{translate('sub_header_component.btn_create')}</span>
                    <span className={classes['icon-caret']}><i className="bi bi-chevron-down" /></span>
                  </Dropdown.Toggle>
                  <Dropdown.Menu className={classes['dropdwn-menu']}>
                    {CIActionGuard([requiredAuthPermission.Services.edit, requiredAuthPermission.Services.approve], permissionObject.permission) && (
                      <Dropdown.Item className={classes['dropdown-select']} as={Link} to="/control-plane/services/createService" state={{ creatreNewEventButtonClicked: true, from: '/control-plane/dashboard' }}>
                        <div className={classes['dropdown-item']}>
                          <ServiceIcon />
                          <span className={classes.item}>
                            {translate('sub_header_component.dropdown_service')}
                          </span>
                        </div>
                      </Dropdown.Item>)}
                    {CIActionGuard([requiredAuthPermission.Events.edit, requiredAuthPermission.Events.approve], permissionObject.permission) && (
                      <Dropdown.Item className={classes['dropdown-select']} as={Link} to="/control-plane/events/createEvent" state={{ creatreNewEventButtonClicked: true, index: null, from: '/control-plane/dashboard' }}>
                        <div className={classes['dropdown-item']}>
                          <EventIcon />
                          <span className={classes.item}>
                            {translate('sub_header_component.dropdown_event')}
                          </span>
                        </div>
                      </Dropdown.Item>)}
                    {CIActionGuard([requiredAuthPermission.JD.approve, requiredAuthPermission.JD.edit], permissionObject.permission) && (
                      <Dropdown.Item className={classes['dropdown-select']} data-testid="create-journey-dropdown-option" as={Link} to={journeyBuilderRoutes.createJourney} state={{ creatreNewEventButtonClicked: true, from: '/control-plane/dashboard' }}>
                        <div className={classes['dropdown-item']}>
                          <JourneyIcon />
                          <span className={classes.item}>
                            {translate('sub_header_component.dropdown_journey')}
                          </span>
                        </div>
                      </Dropdown.Item>)}
                  </Dropdown.Menu>
                </Dropdown>
              </div>)}
          </div>
        </Col>
      </Row>
    </div>
  );
};
export default CreateButtonSubHeader;
